import { useEffect } from 'react';
import { Loading, useGetOne } from 'react-admin';
import { useNavigate, useParams } from 'react-router-dom';

const AssetToUnit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: unit, isLoading } = useGetOne('units', { id });

  useEffect(() => {
    if (!isLoading && unit) {
      // replace: this route only redirects — it renders a spinner and never any content of its
      // own, so its history entry is not somewhere Back can usefully return to. Pushed, Back pops
      // to /assets/:id, this effect fires again and throws the user forward: the trap TVR-1207
      // reports. Replaced, the asset entry is consumed and Back reaches whatever preceded it.
      navigate(`/units/${unit.id}/show`, { replace: true });
    }
  }, [isLoading, unit, navigate]);

  return <Loading />;
};

export default AssetToUnit;
